module.exports = function (svg, content) {
  let viewBox = svg.getAttribute('viewBox') &&
    svg.getAttribute('viewBox').split(' ');

  if (viewBox && viewBox.length === 4) {
    $('body').append(svg);

    viewBox = svg.getClientRects()[0];

    removeLeafNodesOutOfView(svg, viewBox);

    $('body')[0].removeChild(svg);
  }

  return svg;
};

function removeLeafNodesOutOfView (svg, viewBox) {
  const removedNodes = 0;

  try {
    const $leafNodes = $(svg).find(':empty');

    $leafNodes.each(function () {
      if (isCompletelyOutside(this, viewBox)) {
        $(this).remove();
      }
    });
  } catch (err) {}

  return removedNodes > 0;
}

function isCompletelyOutside (el, viewBox) {
  if (!el) return false;

  const bbox = el.getClientRects()[0];

  if (!bbox || !viewBox) return false;

  const boxAngles = getAngles(viewBox);
  const elementAngles = getAngles(bbox);

  const isPartiallyIn = _.any(boxAngles, _.partial(isInternalPoint, bbox)) ||
    _.any(elementAngles, _.partial(isInternalPoint, viewBox));

  return !isPartiallyIn;
}

function isInternalPoint (containerBox, point, threshold = 5) {
  return (containerBox.x + threshold) <= point.x &&
    (containerBox.x + threshold) + containerBox.width >= point.x &&
    (containerBox.y + threshold) <= point.y &&
    (containerBox.y + threshold) + containerBox.height >= point.y;
}

function getAngles (box) {
  return [
    { x: box.x, y: box.y },
    { x: box.x, y: box.y + box.height },
    { x: box.x + box.width, y: box.y },
    { x: box.x + box.width, y: box.y + box.height }
  ].map(angle => {
    return {
      x: Math.ceil(angle.x),
      y: Math.ceil(angle.y)
    };
  });
}
